var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile" }, [
    _c("div", { staticClass: "view-content" }, [
      _c("div", { staticClass: "columns is-multiline is-variable is-full" }, [
        _c("div", { staticClass: "column is-half" }, [
          _c(
            "div",
            { staticClass: "box", class: { short: !_vm.show.details } },
            [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "container__sub-title is-full",
                      on: {
                        click: function ($event) {
                          return _vm.toggleMinimise("details")
                        },
                      },
                    },
                    [
                      _c("h1", { staticClass: "title is-4" }, [
                        _vm._v("My Company Details"),
                      ]),
                      _vm._v(" "),
                      _vm.deviceIsMobile
                        ? _c(
                            "div",
                            { staticClass: "minimise" },
                            [
                              _c("fa", {
                                style: { color: "#fff" },
                                attrs: {
                                  icon: _vm.show.details
                                    ? "chevron-down"
                                    : "chevron-right",
                                  size: "1x",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.show.details
                    ? _c("div", { staticClass: "content" }, [
                        _c("div", { staticClass: "column" }, [
                          _c("div", { staticClass: "box short white" }, [
                            _c("div", { staticClass: "columns" }, [
                              _vm._m(0),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "column is-9 has-text-right" },
                                [_c("p", [_vm._v(_vm._s(_vm.company.name))])]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "box short white" }, [
                            _c("div", { staticClass: "columns" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "column",
                                  class: {
                                    "is-6": _vm.deviceIsMobile,
                                    "is-5": !_vm.deviceIsMobile,
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "has-text-weight-bold is-size-6",
                                    },
                                    [_vm._v("Address")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "column address-column",
                                  class: {
                                    "is-6": _vm.deviceIsMobile,
                                    "is-7": !_vm.deviceIsMobile,
                                  },
                                },
                                [
                                  _vm.company.address.line1
                                    ? _c(
                                        "p",
                                        { staticClass: "has-text-left" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.company.address.line1)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.company.address.line2
                                    ? _c(
                                        "p",
                                        { staticClass: "has-text-left" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.company.address.line2)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.company.address.town
                                    ? _c(
                                        "p",
                                        { staticClass: "has-text-left" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.company.address.town)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.company.address.postcode
                                    ? _c(
                                        "p",
                                        { staticClass: "has-text-left" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.company.address.postcode)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "box short white preference-button",
                            },
                            [
                              _c("div", { staticClass: "columns" }, [
                                _c("div", { staticClass: "column is-12" }, [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$root.openMarketingPreferences()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "preference-text" },
                                        [
                                          _vm._v(
                                            "\n                            Update Your Marketing Preferences\n                            "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "slider-icon" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "button-icon-slider",
                                                },
                                                [
                                                  _c("fa", {
                                                    attrs: {
                                                      icon: "sliders",
                                                      size: "m",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "buttonIcon" },
                                        [
                                          _c("fa", {
                                            attrs: {
                                              icon: "arrow-right",
                                              size: "m",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column is-half hide-on-mobile" }, [
          _c(
            "div",
            { staticClass: "slider-container box" },
            [_c("ad-carousel")],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column is-half" }, [
          _c(
            "div",
            { staticClass: "box", class: { short: !_vm.show.contacts } },
            [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "container__sub-title is-full",
                      on: {
                        click: function ($event) {
                          return _vm.toggleMinimise("contacts")
                        },
                      },
                    },
                    [
                      _c("h1", { staticClass: "title is-4" }, [
                        _vm._v("My Company Contacts"),
                      ]),
                      _vm._v(" "),
                      _vm.deviceIsMobile
                        ? _c(
                            "div",
                            { staticClass: "minimise" },
                            [
                              _c("fa", {
                                style: { color: "#fff" },
                                attrs: {
                                  icon: _vm.show.contacts
                                    ? "chevron-down"
                                    : "chevron-right",
                                  size: "1x",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.show.contacts
                    ? _c("div", { staticClass: "content" }, [
                        _c(
                          "div",
                          { staticClass: "column" },
                          _vm._l(_vm.contacts, function (contact) {
                            return _c(
                              "div",
                              { staticClass: "box short white is-12" },
                              [
                                _c("div", { staticClass: "column" }, [
                                  _c("div", { staticClass: "columns" }, [
                                    _c("div", { staticClass: "column is-4" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "has-text-weight-bold is-size-6",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("title")(contact.name)
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column is-8" },
                                      [
                                        _vm._l(
                                          contact.telephones,
                                          function (telephone, index) {
                                            return _c("div", [
                                              _c(
                                                "p",
                                                { staticClass: "telephone" },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(telephone)
                                                  ),
                                                  index < contact.length - 1
                                                    ? _c("span")
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ])
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          contact.emails,
                                          function (email) {
                                            return _c("div", [
                                              _c(
                                                "p",
                                                { staticClass: "email" },
                                                [_vm._v(_vm._s(email))]
                                              ),
                                            ])
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column is-half" }, [
          _c(
            "div",
            { staticClass: "box", class: { short: !_vm.show.services } },
            [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "container__sub-title is-full",
                      on: {
                        click: function ($event) {
                          return _vm.toggleMinimise("services")
                        },
                      },
                    },
                    [
                      _c("h1", { staticClass: "title is-4" }, [
                        _vm._v("My Active Services"),
                      ]),
                      _vm._v(" "),
                      _vm.deviceIsMobile
                        ? _c(
                            "div",
                            { staticClass: "minimise" },
                            [
                              _c("fa", {
                                style: { color: "#fff" },
                                attrs: {
                                  icon: _vm.show.services
                                    ? "chevron-down"
                                    : "chevron-right",
                                  size: "1x",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.show.services
                    ? _c("div", { staticClass: "content" }, [
                        _c(
                          "div",
                          { staticClass: "column" },
                          _vm._l(_vm.services, function (service) {
                            return _c(
                              "div",
                              { staticClass: "box short white is-12" },
                              [
                                _c("div", { staticClass: "column" }, [
                                  _c("div", { staticClass: "columns" }, [
                                    _c("div", { staticClass: "column is-6" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "has-text-weight-bold is-size-6",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("title")(
                                                service.product.name
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "column is-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "columns is-12" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "column is-6" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "has-text-weight-bold is-size-6",
                                                },
                                                [_vm._v("Status")]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("title")(
                                                      _vm.getServiceState(
                                                        service
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "column is-6" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "has-text-weight-bold is-size-6",
                                                },
                                                [_vm._v("Expires")]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getServiceExpiry(
                                                      service
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column is-half" }, [
          _c(
            "div",
            { staticClass: "box", class: { short: !_vm.show.markUps } },
            [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "container__sub-title is-full",
                      on: {
                        click: function ($event) {
                          return _vm.toggleMinimise("markUps")
                        },
                      },
                    },
                    [
                      _c("h1", { staticClass: "title is-4" }, [
                        _vm._v("My Mark-Ups"),
                      ]),
                      _vm._v(" "),
                      _vm.deviceIsMobile
                        ? _c(
                            "div",
                            { staticClass: "minimise" },
                            [
                              _c("fa", {
                                style: { color: "#fff" },
                                attrs: {
                                  icon: _vm.show.markUps
                                    ? "chevron-down"
                                    : "chevron-right",
                                  size: "1x",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.show.markUps
                    ? _c("div", { staticClass: "content" }, [
                        _c(
                          "div",
                          { staticClass: "column" },
                          _vm._l(_vm.markUps, function (markUp, key) {
                            return _c(
                              "div",
                              { staticClass: "is-12 box short white" },
                              [
                                _c("div", { staticClass: "columns" }, [
                                  _c("div", { staticClass: "column is-6" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "has-text-weight-bold has-text-left",
                                      },
                                      [_vm._v(_vm._s(_vm._f("title")(key)))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "column is-6" }, [
                                    _c(
                                      "div",
                                      { staticClass: "has-text-right" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm._f("percentage")(markUp))
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column is-half" }, [
          _c(
            "div",
            { staticClass: "box", class: { short: !_vm.show.labourRates } },
            [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "container__sub-title is-full",
                      on: {
                        click: function ($event) {
                          return _vm.toggleMinimise("labourRates")
                        },
                      },
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _vm.deviceIsMobile
                        ? _c(
                            "div",
                            { staticClass: "minimise" },
                            [
                              _c("fa", {
                                style: { color: "#fff" },
                                attrs: {
                                  icon: _vm.show.labourRates
                                    ? "chevron-down"
                                    : "chevron-right",
                                  size: "1x",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.show.labourRates
                    ? _c("div", { staticClass: "content" }, [
                        _c(
                          "div",
                          { staticClass: "column" },
                          _vm._l(_vm.labourRates, function (labourRate, key) {
                            return _c(
                              "div",
                              { staticClass: "is-12 box short white" },
                              [
                                _c("div", { staticClass: "columns" }, [
                                  _c("div", { staticClass: "column is-6" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "has-text-weight-bold has-text-left",
                                      },
                                      [_vm._v(_vm._s(_vm._f("title")(key)))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "column is-6" }, [
                                    _c(
                                      "div",
                                      { staticClass: "has-text-right" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currencyNotReduced")(
                                              labourRate
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("p", { staticClass: "has-text-weight-bold is-size-6" }, [
        _vm._v("Name"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "title is-4" }, [
      _vm._v("My Labour Rates "),
      _c("span", { attrs: { id: "per-hour-font" } }, [_vm._v("(per hour)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }